import _ from 'lodash';
import { connect } from 'react-redux';
import { importLoadingNumbers, get, update } from '../../modules/logistics/loadingAssignment';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	let loadingAssignment;
	let loadingAssignmentId;

	if (ownProps.loadingAssignment) {
		loadingAssignment = ownProps.loadingAssignment;
	} else {
		loadingAssignmentId = (ownProps.loadingAssignmentId)
			? ownProps.loadingAssignmentId
			: _.get(ownProps, ['match', 'params', 'loadingAssignmentId']);
		loadingAssignment = _.get(state.maps, ['loadingAssignment', loadingAssignmentId]);
	}

	return {
		loadingAssignment,
		stationMap : state.maps.station,
		userMap : state.maps.user,
		resourceMap : state.maps.resource,
		carrierMap : state.maps.carrier,
		terminalMap : state.maps.terminal,
		supplierMap : state.maps.supplier,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	importLoadingAssignment : importLoadingNumbers,
	getLoadingAssignment : get,
	updateLoadingAssignment : update,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
